/**
 * App Notification Type Enum
 * 
 * Matches Flutter's AppNotificationType enum EXACTLY.
 * Source: lib/domain/enums/app_notification_type.dart
 * 
 * IMPORTANT: These must stay in sync with Flutter. Any changes to Flutter
 * enum must be reflected here.
 * 
 * Pattern: Uses numeric values (enum index) matching Flutter's .index
 */
export enum AppNotificationType {
  contentLike = 0,
  contentComment = 1,
  commentLike = 2,
  commentReply = 3,
  contentGift = 4,
  liveStarted = 5,
  contentMention = 6,
  commentMention = 7,
  reportContent = 8,
  reportUser = 9,
  unlockContent = 10,
  identityVerification = 11,
  premiumPackage = 12,
  premiumPackageExpired = 13,
  exclusiveSubscription = 14,
  exclusiveSubscriptionExpired = 15,
  exclusiveSubscriptionRenewd = 16,
  exclusiveSubscriptionRequested = 17,
  exclusiveSubscriptionRequestCancelled = 18,
  exclusiveSubscriptionRequestAccepted = 19,
  exclusiveSubscriptionRequestDeclined = 20,
  exclusiveSubscriptionFailedInsufficientCoins = 21,
  scheduleContent = 22,
  scheduleContentPublished = 23,
  campaignRanking = 24,
  contentAdded = 25,
  roadmapLike = 26,
  roadmapDislike = 27,
  roadmapComment = 28,
  roadmapCommentReply = 29,
  roadmapCommentLike = 30,
  roadmapDonation = 31,
  payPremiumVideo = 32,
  payPremiumVideoFailed = 33,
  earlyAccessContentAdded = 34,
  earlyAccessContentReceived = 35,
  payBoostVideo = 36,
  payBoostVideoFailed = 37,
}
